module.exports = __webpack_public_path__ + "static/media/trend-up.1abd0b55.svg";